import { render, staticRenderFns } from "./inventoryValueChartWidget.vue?vue&type=template&id=774772b6&"
import script from "./inventoryValueChartWidget.vue?vue&type=script&lang=js&"
export * from "./inventoryValueChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports